import { statisticControllerGetCertificatesByRegionCount } from './statisticControllerGetCertificatesByRegionCount'
import { statisticControllerGetDemographics } from './statisticControllerGetDemographics'
import { statisticControllerGetGenderStatistics } from './statisticControllerGetGenderStatistics'
import { statisticControllerGetGroupsCountForStatistic } from './statisticControllerGetGroupsCountForStatistic'
import { statisticControllerGetGroupsRegisterStatics } from './statisticControllerGetGroupsRegisterStatics'
import { statisticControllerGetPassedExamsByAge } from './statisticControllerGetPassedExamsByAge'
import { statisticControllerGetSchoolRegisterStatistics } from './statisticControllerGetSchoolRegisterStatistics'
import { statisticControllerGetSchoolsExamsStatistics } from './statisticControllerGetSchoolsExamsStatistics'
import { statisticControllerGetSchoolStatistic } from './statisticControllerGetSchoolStatistic'
import { statisticControllerGetStudentsStatistics } from './statisticControllerGetStudentsStatistics'
import { statisticControllerGetUserRegisterStatistics } from './statisticControllerGetUserRegisterStatistics'
import { statisticControllerGetUsersByCategoryStatistics } from './statisticControllerGetUsersByCategoryStatistics'
import { statisticControllerGetUsersByRegionStatistics } from './statisticControllerGetUsersByRegionStatistics'
import { statisticControllerGetUsersBySchoolStatistics } from './statisticControllerGetUsersBySchoolStatistics'
import { statisticControllerGetUserStatistics } from './statisticControllerGetUserStatistics'
import { statisticControllerMainStatistics } from './statisticControllerMainStatistics'
import { statisticControllerSchoolsOverview } from './statisticControllerSchoolsOverview'
import { statisticControllerTicketStatistic } from './statisticControllerTicketStatistic'

export const statisticService = {
    statisticControllerGetSchoolStatistic,
    statisticControllerGetGroupsCountForStatistic,
    statisticControllerGetStudentsStatistics,
    statisticControllerGetCertificatesByRegionCount,
    statisticControllerGetUserStatistics,
    statisticControllerGetSchoolRegisterStatistics,
    statisticControllerGetGroupsRegisterStatics,
    statisticControllerGetDemographics,
    statisticControllerGetGenderStatistics,
    statisticControllerGetUsersByRegionStatistics,
    statisticControllerGetUsersByCategoryStatistics,
    statisticControllerGetSchoolsExamsStatistics,
    statisticControllerGetPassedExamsByAge,
    statisticControllerGetUserRegisterStatistics,
    statisticControllerGetUsersBySchoolStatistics,
    statisticControllerSchoolsOverview,
    statisticControllerMainStatistics,
    statisticControllerTicketStatistic,
  }